module.exports = __webpack_public_path__ + "static/media/Lineamientos generales para la comprensión, detección y prevención. UBA, 2016.89877e53.pdf";